import React from 'react';
import SettingsHistorySection from '../../../sections/AdminDashboard/Settings/SettingsHistory';

const SettingsHistory = () => {
  return <SettingsHistorySection />;
};

export default SettingsHistory;
